/**
 * Toggle the product CTA between Add to Cart and the existing AMP waitlist trigger.
 *
 * @param {HTMLElement} productContainer
 * @param {HTMLElement | null} selectedVariant
 * @returns {void}
 */
const updateProductWaitlistState = (productContainer, selectedVariant) => {
  if (!productContainer || !selectedVariant) return;

  const waitlistButton = productContainer.querySelector('[data-waitlist-trigger]');
  const submitButton = productContainer.querySelector('[data-product-submit]');
  const activePackButton = productContainer.querySelector('.pack-option-btn.active');
  const isSinglePack = !activePackButton || activePackButton.dataset.packSize === '1';
  const isAvailable = selectedVariant.dataset.available !== 'false';
  const shouldShowWaitlist = isSinglePack && !isAvailable;

  if (waitlistButton) {
    waitlistButton.hidden = !shouldShowWaitlist;

    if (shouldShowWaitlist) {
      const variantId = selectedVariant.dataset.variantId || selectedVariant.dataset.id;
      if (variantId) waitlistButton.setAttribute('data-variant-id', variantId);
    }
  }

  if (submitButton) {
    submitButton.hidden = shouldShowWaitlist;
    submitButton.disabled = shouldShowWaitlist;
  }
};

if (typeof window !== 'undefined') {
  window.EquipProductWaitlist = { updateProductWaitlistState };
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { updateProductWaitlistState };
}
